import { render, staticRenderFns } from "./WarningProductsMidia.vue?vue&type=template&id=09343060"
import script from "./WarningProductsMidia.vue?vue&type=script&lang=js"
export * from "./WarningProductsMidia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports